<template>
  <b-field :label="label" :custom-class="customLabelClass">
    <div class="buttons are-small has-addons">
      <b-button
        :class="{ 'is-selected is-success': value === 2 }"
        :disabled="disabled"
        @click.prevent="$emit('input', 2)"
        >Yes</b-button
      >
      <b-button
        :class="{ 'is-selected is-info': value === 1 }"
        :disabled="disabled"
        @click.prevent="$emit('input', 1)"
        >SomeWhat</b-button
      >
      <b-button
        :class="{ 'is-selected is-danger': value === 0 }"
        :disabled="disabled"
        @click.prevent="$emit('input', 0)"
        >No</b-button
      >
    </div>
  </b-field>
</template>

<script>
export default {
  props: {
    value: { type: Number, default: 0 },
    disabled: Boolean,
    label: { type: String, default: 'Rating:' },
    customLabelClass: { type: String, default: '' }
  }
};
</script>

<style></style>
